import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { WaitlistForm } from "./WaitlistForm";
import { StoreBadges } from "./StoreBadges";
import { Reveal } from "./Reveal";

export const FinalCTA = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });

  return (
    <section id="waitlist" className="relative bg-diem-ink py-32 sm:py-44 overflow-hidden" data-testid="final-cta-section">
      <div className="absolute inset-0 opacity-30" style={{ background: "radial-gradient(800px 480px at 50% 110%, #0055FF, transparent 65%)" }} />
      <div className="relative max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-diem-sky mb-8">Be first</p>
        </Reveal>
        <h2 ref={ref} className="font-display font-medium tracking-tighter leading-[0.95] text-[15vw] sm:text-8xl text-white" data-testid="final-cta-headline">
          {[
            <>Send me</>,
            <>a <span className="text-diem-blue">Deyem.</span></>,
          ].map((line, i) => (
            <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
              <motion.span
                className="block"
                initial={false}
                animate={inView ? { y: "0%" } : { y: "112%" }}
                transition={{ duration: 1, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
              >
                {line}
              </motion.span>
            </span>
          ))}
        </h2>
      <Reveal delay={0.25}>
        <p className="mt-6 font-display text-2xl sm:text-3xl font-medium tracking-tight text-white/60">
          Messaging that remembers.
        </p>
      </Reveal>
      <Reveal delay={0.35}>
        <div className="mt-12 flex justify-center">
          <WaitlistForm dark source="final-cta" />
        </div>
        <div className="mt-8 flex justify-center">
          <StoreBadges dark />
        </div>
        <p className="mt-5 text-[13px] text-white/40 font-medium">
          Download now — or join the waitlist for launch news and Founding Member offers.
        </p>
      </Reveal>
    </div>
    <div className="relative mt-24 sm:mt-32 flex justify-center overflow-hidden" aria-hidden="true">
      <motion.span
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }}
        className="font-display font-semibold tracking-tighter leading-none text-[24vw] sm:text-[13rem] text-stroke select-none"
      >
        Deyem
      </motion.span>
    </div>
    </section>
  );
};
